<template>
<v-app>
<v-main
    style="padding-left: 30px; padding-right: 30px"
>

    <div
        style="text-align: center; margin-top: 30px; margin-bottom: 30px;"
    >
        <img 
            src="@/assets/redchirp-logo-square-center.png" 
            style="width: 100px; vertical-align: middle;"
        />

        <span
            style="font-size: 20px; font-weight: bold; margin-left: 15px;"
        >
            Wineshipping Link Tree
        </span>

    </div>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickUtilizationReport()"
                >
                    <v-list-item-title>Utilization Report...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

    

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
        
    >
        <template v-slot:item.time_create_date="{ item }">
            {{$rc.pretty(item.time_create, 'date')}}
        </template>

        <template v-slot:item.time_create_time="{ item }">
            {{$rc.pretty(item.time_create, 'time')}}
        </template>

        <template v-slot:item.tracking_url_pattern="{ item }">
            <a 
                style="text-decoration: underline" 
            >
                {{item.tracking_url_pattern}}
            </a>
            <v-icon 
                dense
                v-on:click="onClickTrackingLink(item)"
                color="primary"
                style="pointer-events: auto;"
                class="ml-1"
            >
                mdi-lead-pencil
            </v-icon>
        </template>

        
    
        <template v-slot:item.action="{ item }">
             <v-icon
                v-on:click="onClickCopy(item)"
            >
                mdi-content-copy
            </v-icon>
        </template>
    
    </v-data-table>

    <m-report-progress-dialog
        ref="progress-dialog"
        public
     />

</v-main>


  <m-global-spinner/>
  <m-global-snackbar/>
  <m-global-alert/>
  <m-global-confirm/>
  <m-global-prompt/>

</v-app>
</template>

<script>
const _ = require('lodash');
export default {
    data() {
        return {
            full_text: null,
            headers: [
                { text: 'Creation Date', value: 'time_create_date'},
                { text: 'Creation Time', value: 'time_create_time'},
                { text: 'Organization', value: 'organization_label'},
                { text: 'Webhook Url', value: 'webhook_url'},
                { text: 'Tracking Url', value: 'tracking_url_pattern'},
                { text: 'Action', value: 'action'},
            ],
            results: [],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/link-tree/wine-shipping',
            
                'params' : {
                        'auth': this.$route.params.auth,
                        'full_text': this.full_text,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to complete API call',
            });
        },

        onClickCopy(item)
        {
            this.$rc.copy(item.webhook_url);
        },

        onClickTrackingLink(item)
        {
            this.$rc.prompt({
                'title': 'Set tracking URL pattern',
                'label': 'Set tracking URL pattern',
                'value': item.tracking_url_pattern,
                'unset_label': null,
                'is_valid': null,
            
                'after_prompt': (value) => {
                    
                    if ( !value.includes("{tracking-number}") )
                    {
                        this.$rc.alert('Must contain {tracking-url}', 'The tracking url pattern must contain the variable {tracking-url}.');
                        return;
                    }


                    this.$rc.rest({
                        'spinner': false,
                        'endpoint': 'PUT: /api/v1/link-tree/wine-shipping/tracking-url-pattern',
                    
                        'params' : {
                                'auth': this.$route.params.auth,
                                'organization_id': item.organization_id,
                                'tracking_url_pattern': value
                            },
                    
                        'on_success': (data) => {
                                this.doUpdate();
                            },
                    
                        'on_error': 'Unable to update tracking url',
                    });

                },
            });
        },

        onClickUtilizationReport()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/reports/run/public',
            
                'params' : {
                        'report_id': 'BI_WINE_SHIPPING_AUTO_MESSAGE_UTILIZATION',
                        'database': 'production',
                    },
            
                'on_success': (data) => {
                        this.$refs['progress-dialog'].showDialog(data);
                    },
            
                'on_error': 'Unable to start report',
            });
        },
        
    },
}
</script>

<style lang="scss" scoped>
</style>